import { styled } from '@mui/material/styles';
import ReactMarkdown from 'react-markdown';

import {
    containerSmallWidth,
    containerLargeWidth,
    Theme,
    rem,
    remToGapMultiplier,
} from '../../theme';

import { StyledReactMarkdownProperties } from './RichTextContent.types';

// This is a gutterBottom workaround for reactMarkDown.
// We only allow gutterBottom on paragraphs for children of the root rich text element.
// All other Paragraphs contain no margin-bottom
export const StyledReactMarkdown = styled(ReactMarkdown, {
    shouldForwardProp: property =>
        typeof property === 'string' && !property.startsWith('$'),
})<StyledReactMarkdownProperties>`
    ${({ theme }: { theme: Theme }) => theme.typography.bodyStandard};
    > p {
        ${({ theme }: { theme: Theme }) => theme.typography.bodyStandard};
        ${({ theme }: { theme: Theme }) => `
            margin-bottom: ${theme.tggSpacing(rem(1), 2.5)};

            ${theme.breakpoints.up('desktop')} {
                margin-bottom: ${theme.tggSpacing(rem(2), 5)};
            }
	    `}
    }
    ${({
        theme,
        $fullWidth,
        $isItInGymLocation,
        $alignOnDesktop,
    }: StyledReactMarkdownProperties & {
        theme: Theme;
        $alignOnDesktop?: string;
    }) => `
        max-width: ${
            $fullWidth
                ? 'none'
                : $isItInGymLocation
                  ? theme.tggSpacing(rem(66), 165)
                  : theme.tggSpacing(
                        rem(containerSmallWidth),
                        containerSmallWidth * remToGapMultiplier,
                    )
        };
        padding: ${$fullWidth ? theme.tggSpacing(0, 0) : theme.tggSpacing([0, rem(3)], [0, 7.5])};
        margin: ${theme.tggSpacing([0, 'auto'], [0, 'auto'])};

        

        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing(0, 0)};
            text-align: ${$alignOnDesktop || 'inherit'};
        }

	`}
`;

export const StyledContainer = styled('div')<StyledReactMarkdownProperties>`
    ${({
        theme,
        $fullWidth,
    }: StyledReactMarkdownProperties & { theme: Theme }) => `
        max-width: ${$fullWidth ? 'none' : theme.tggSpacing(rem(containerLargeWidth), containerLargeWidth * remToGapMultiplier)};
        margin: ${theme.tggSpacing([0, 'auto'], [0, 'auto'])};
	`}
`;
